import Highcharts from 'highcharts';

export const createDefaultLegendOptions = (
): Highcharts.CreditsOptions => ({
  enabled: false,
});
